import React from "react";
import { useNavigate } from "react-router-dom";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CommonButton } from "../button/Button";
import { useTranslation } from "react-i18next";
const TeamsDataDeleteModal = ({ handleClose, HandleDeleteConfirmation }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className="d-flex justify-content-between pb-5">
        <h3>Delete Record</h3>
        <FontAwesomeIcon
          icon={faTimes}
          size="12px"
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </div>
      <p>Are you sure you want to delete this record?</p>

      <div className="d-flex justify-content-end pt-5">
        <CommonButton
          click={handleClose}
          title={t("cancel")}
          borderRadius="5px"
          bgColor="#ffff"
          color="#000"
          margin="0 10px 0 0"
          hoverBgColor="#ffff"
        />
        <CommonButton
          click={() => HandleDeleteConfirmation()}
          title="DELETE"
          border="none"
          borderRadius="5px"
        />
      </div>
    </div>
  );
};

export default TeamsDataDeleteModal;
